import { Card, Form, InputNumber } from "antd";

import CheckboxField from "./CheckboxField";
import StatusChecklistSection from "./StatusChecklistSection";

interface NotificationsSectionProps {
  serviceRequestsEnabled: boolean;
}

const NotificationsSection = ({ serviceRequestsEnabled }: NotificationsSectionProps) => (
  <Card title="Notifications" type="inner">
    {serviceRequestsEnabled && <CheckboxField name="receive_service_requests" label="Receive Service Requests" />}
    <CheckboxField name="allow_disabling_chirp" label="Allow Disable Chirp" />
    <Form.Item name="forced_volume_level" label="Forced Volume Level (Android Only, 0-1)">
      <InputNumber id="dp-forced-volume-level" min={0} max={1} step={0.1} />
    </Form.Item>
    <StatusChecklistSection id="dp-statuses-to-chirp" label="Statuses to Chirp For" name="statuses_to_chirp_for" />
  </Card>
);

export default NotificationsSection;
